import React from 'react';
import 'bootstrap/dist/css/bootstrap.min.css';
const Footer = () => {

    return (
        <footer className="footer fixed-bottom bg-light">
            <div className="container my-2">
                <span className="text-muted" style={{ fontSize: '12px' }}>© 2001-2024 Accenture. All rights reserved. Terms of Use | Privacy Statement | The Optimal resolution to view our Portal is 1366*768,1600*900 and 1920*1080(150%) in EDGE and Chrome Browser.</span>
            </div>
        </footer>
    );
};

export default Footer;
